import React from 'react';
import PropTypes from 'prop-types';

import { TextButton, PrimaryButton, SecondaryButton } from './Buttons.styled';
import { StyledDialogActions, Container } from './DialogActions.styled';

const DialogActions = ({ primary, secondary, border }) => {
  const primaryActionProps = {
    variant: 'contained',
    onClick: primary.onClick,
    danger: primary.danger,
    disabled: primary.disabled || primary.loading,
    loading: primary.loading,
    primary,
  };

  const primaryAction = primary.textButton ? (
    <TextButton {...primaryActionProps}>{primary.label}</TextButton>
  ) : (
    <PrimaryButton {...primaryActionProps}>{primary.label}</PrimaryButton>
  );

  const SecondaryComponent =
    secondary && secondary.textButton ? TextButton : SecondaryButton;
  const secondaryAction = secondary ? (
    <SecondaryComponent
      variant="outlined"
      onClick={secondary.onClick}
      disabled={secondary.disabled || secondary.loading}
      loading={secondary.loading}
    >
      {secondary.label}
    </SecondaryComponent>
  ) : null;

  return (
    <Container border={border}>
      <StyledDialogActions>
        {secondaryAction}
        {primaryAction}
      </StyledDialogActions>
    </Container>
  );
};

const ActionProperties = PropTypes.shape({
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  danger: PropTypes.bool,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
});

DialogActions.propTypes = {
  primary: ActionProperties.isRequired,
  secondary: ActionProperties,
  border: PropTypes.bool,
};

DialogActions.defaultProps = {
  secondary: null,
  border: true,
};

export default DialogActions;
